import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SearchBarAdapterService {
  rawEstablishmentToEstablishment(
    rawEstablishment: RawEstablishment
  ): Establishment {
    const today = new Date();
    const currentHour =
      today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    let isOpen;

    if (
      currentHour >= rawEstablishment.apertura &&
      currentHour <= rawEstablishment.cierre
    ) {
      isOpen = true;
    } else {
      isOpen = false;
    }
    const cierreArray = rawEstablishment.cierre.split(":")
    cierreArray.pop()
    const cierreTransformer = gestDictionary(cierreArray?.[0]);
    const truncateCierre = cierreTransformer.hour+ ":" + cierreArray?.[1] + " " + cierreTransformer.pair;

    return {
      id_restaurant: rawEstablishment.id_restaurant,
      address: rawEstablishment.address,
      truncateAddress: rawEstablishment.address.split(",")?.[0]?.split("-")?.[0],
      isOpen,
      cierre: rawEstablishment.cierre,
      apertura: rawEstablishment.apertura,
      name_restaurant: rawEstablishment.name_restaurant,
      picture_logo: rawEstablishment.picture_logo,
      picture_establishment: rawEstablishment.picture_establishment,
      truncateCierre,
      time_order: rawEstablishment.time_order,
    };
  }

  rawProductToProduct(rawProduct:any): any{
    return {
      ...rawProduct,
      pd_description: rawProduct?.pd_description?.split(/[\n\r\t]+/).join(", ") 
    }
  }
}

export interface RawEstablishment {
  id_restaurant: number;
  name_restaurant: string;
  picture_logo: string;
  picture_establishment: string;
  address: string;
  phone: string;
  latitude: number;
  longitude: number;
  isOpen: boolean;
  apertura: string;
  cierre: string;
  time_order: string;
  costo_envio: number;
  avgStart: number;
  commentTotal: number;
  isFavorite: boolean;
  creditos: number;
  distance: number;
  lastOrder: Date;
  inRange: boolean;
}

export interface Establishment {
  id_restaurant: number;
  name_restaurant: string;
  picture_logo: string;
  picture_establishment: string;
  address: string;
  truncateAddress: string;
  truncateCierre: string;
  isOpen: boolean;
  cierre: string;
  apertura: string;
  time_order: string;
}


export function gestDictionary(hour: string): any {
  const dictionary = {
    "01": {hour: "01", pair: "AM"},
    "02": {hour: "02", pair: "AM"},
    "03": {hour: "03", pair: "AM"},
    "04": {hour: "04", pair: "AM"},
    "05": {hour: "05", pair: "AM"},
    "06": {hour: "06", pair: "AM"},
    "07": {hour: "07", pair: "AM"},
    "08": {hour: "08", pair: "AM"},
    "09": {hour: "09", pair: "AM"},
    "10": {hour: "10", pair: "AM"},
    "11": {hour: "11", pair: "AM"},
    "12": {hour: "12", pair: "PM"},
    "13": {hour: "01", pair: "PM"},
    "14": {hour: "02", pair: "PM"},
    "15": {hour: "03", pair: "PM"},
    "16": {hour: "04", pair: "PM"},
    "17": {hour: "05", pair: "PM"},
    "18": {hour: "06", pair: "PM"},
    "19": {hour: "07", pair: "PM"},
    "20": {hour: "08", pair: "PM"},
    "21": {hour: "09", pair: "PM"},
    "22": {hour: "10", pair: "PM"},
    "23": {hour: "11", pair: "PM"},
    "24": {hour: "12", pair: "AM"},
    "00": {hour: "12", pair: "AM"},
  } as const;
  return dictionary?.[hour as keyof typeof dictionary];
}